import React from "react"

const Dialog=()=>{
   return (
     <h1>Dialog</h1>
   )
}

export default Dialog